import { createContext } from 'react'

export const AuthContext = createContext({
  token: null,
  hasAccess: false,
  authInitialized: false,
  setToken: () => {},
  markHasAccess: () => {},
  markNoAccess: () => {},
  redirectToLogin: () => {},
  decodeToken: () => null,
})
